export default "__VITE_ASSET__CgqgmOw4__"